import { useEffect, useState } from "react";
import { fetchUnits, downloadUnitsExcel } from "../Api/ViewUnitMaster";
import { Container, Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import moment from "moment";

const ViewUnitMaster = () => {
  const [units, setUnits] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const loadUnits = async () => {
      try {
        const data = await fetchUnits();
        setUnits(data || []);
      } catch (error) {
        toast.error(`🦄 Error Fetching Units`);
      }
    };

    loadUnits();
  }, []);

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      const response = await downloadUnitsExcel();
      
      if (!response.data) {
        throw new Error("No data received from server");
      }
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Units_Data.xlsx');
      
      // Trigger download
      document.body.appendChild(link);
      link.click();
      
      // Cleanup
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        link.parentNode.removeChild(link);
      }, 100);
      
      toast.success("Units data download started!");
    } catch (error) {
      console.error("Download error:", error);
      toast.error(`🦄 Download failed: ${error.message}`);
    } finally {
      setIsDownloading(false);
    }
  };

  const handleAddUnit = () => {
    navigate("/unit-master");
  };

  return (
    <>
      <div>
        <Container className="list-container">
          <div className="header-background">
            <h2 className="header-list-title">View Units</h2>
            <div>
              <Button 
              style={{
                marginBottom:'2px'
              }}
                variant="success" 
                onClick={handleAddUnit}
                className="gradient-btn green-btn"
              >
                Add Units
              </Button>
              <Button 
                variant="primary" 
                className="gradient-btn"
                onClick={handleDownload}
                disabled={isDownloading || units.length === 0}
              >
                {isDownloading ? 'Downloading...' : 'Download Data'}
              </Button>
            </div>
          </div>

          {units.length > 0 ? (
            <Table bordered hover responsive className="data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Code</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>Created On</th>
                  <th>Created By</th>
                  <th>Changed On</th>
                  <th>Changed By</th>
                </tr>
              </thead>
              <tbody>
                {units.map((unit, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{unit.code}</td>
                    <td>{unit.description}</td>
                    <td>{unit.type}</td>
                    <td>
                      {moment(unit.createdOnDate).format('L')} at {unit.createdOnTime?.substring(0, 8)}
                    </td>
                    <td>{unit.createdBy}</td>
                    <td>
                      {unit.changedOnDate ? 
                        `${moment(unit.changedOnDate).format('L')} at ${unit.changedOnTime?.substring(0, 8)}` 
                        : 'N/A'}
                    </td>
                    <td>{unit.changedBy || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : (
            <p className="no-data">No units found.</p>
          )}
        </Container>
      </div>
    </>
  );
};

export default ViewUnitMaster;